import { Link } from 'react-router-dom';

const programs = [
  {
    icon: 'ri-line-chart-line',
    title: 'Тренинг по продажам',
    desc: 'Комплексное развитие отдела продаж: от диагностики до роста конверсии. Когда нужна системная перестройка навыков всей команды.',
    to: '/prodazhi-i-peregovory/trening-po-prodazham',
  },
  {
    icon: 'ri-discuss-line',
    title: 'Тренинг по переговорам',
    desc: 'Для сложных переговоров, защиты цены и работы с закупщиками. Уверенные стратегии win-win и управление переговорным процессом.',
    to: '/prodazhi-i-peregovory/trening-po-peregovoram',
  },
  {
    icon: 'ri-phone-find-line',
    title: 'Холодные звонки',
    desc: 'От страха звонка до уверенного выхода на ЛПР. Скрипты, обход секретаря, обработка типовых отказов.',
    to: '/prodazhi-i-peregovory/trening-po-holodnym-zvonkam',
  },
  {
    icon: 'ri-phone-line',
    title: 'Телефонные продажи',
    desc: 'Современные техники телефонных продаж в эпоху мессенджеров. Когда клиент сначала пишет, а потом звонит.',
    to: '/prodazhi-i-peregovory/trening-po-telefonnym-prodazham',
  },
  {
    icon: 'ri-chat-check-line',
    title: 'Работа с возражениями',
    desc: 'Перестаём спорить и оправдываться. Алгоритмы обработки ценовых, психологических и скрытых возражений.',
    to: '/prodazhi-i-peregovory/trening-po-rabote-s-vozrazheniyami',
  },
  {
    icon: 'ri-search-eye-line',
    title: 'Выявление потребностей',
    desc: 'SPIN, глубинное интервью, открытые вопросы. Как понять истинную потребность клиента до презентации.',
    to: '/prodazhi-i-peregovory/trening-po-vyyavleniyu-potrebnostey',
  },
  {
    icon: 'ri-building-2-line',
    title: 'Продажи B2B',
    desc: 'Длинный цикл сделки, несколько ЛПР, тендеры и закупщики. Системный подход к корпоративным продажам.',
    to: '/prodazhi-i-peregovory/trening-po-prodazham-b2b',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Работа с клиентами',
    desc: 'Коммуникация, сервис, доверие и долгосрочные отношения. Качество общения напрямую влияет на продажи.',
    to: '/prodazhi-i-peregovory/trening-po-rabote-s-klientami',
  },
  {
    icon: 'ri-chat-1-line',
    title: 'Продажи через переписку',
    desc: 'Telegram, WhatsApp, CRM, e-mail. Обучение менеджеров продавать в мессенджерах без давления и шаблонов.',
    to: '/prodazhi-i-peregovory/trening-po-prodazham-cherez-perepisku',
  },
];

export default function ProgramNavigator() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Как выбрать программу обучения
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto">
          Каждая программа создаётся под конкретную компанию, отрасль и задачи бизнеса. Выберите направление — я помогу адаптировать под вас.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {programs.map((prog, i) => (
            <div key={i} className="bg-white rounded-xl p-5 md:p-6 hover:shadow-lg transition-all group border border-gray-100 flex flex-col">
              <div className="w-12 h-12 bg-teal-600 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <i className={`${prog.icon} text-xl text-white`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-base mb-2 group-hover:text-teal-700 transition-colors">
                {prog.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-5 flex-1">{prog.desc}</p>
              <div className="flex items-center gap-3">
                <Link
                  to={prog.to}
                  className="bg-teal-600 text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center gap-1.5"
                >
                  Подробнее
                  <i className="ri-arrow-right-line text-xs"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <p className="text-gray-500 text-sm mb-4">
            Не знаете, с чего начать? Помогу определить приоритетные направления для вашей команды.
          </p>
          <button
            onClick={() => scrollTo('contact')}
            className="bg-teal-600 text-white px-8 py-3 rounded-lg text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Подобрать программу обучения
            <i className="ri-chat-3-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}